export default __webpack_public_path__ + "static/media/tability_presentation_bkg.c707fa5a.png";